/* xk-launch · XKAH launch panels (homepage tpw-xkah-ladder, collection tpw-xkah-store). Founder-picked motion M2.
   1. Colour dots (links): on mouse hover or keyboard focus, preview that colour's photo with a 180ms opacity
      crossfade and point the panel's links at that colour's listing. A tap or click simply follows the link.
   2. In & Out dots (buttons): pick the Pro and Lite colour; swap that half's photo and point the button at the
      bundle variant "<Pro> / <Lite>". Without this script every link still works.
   3. Bundle product pages: the photo picker drives pdpv9's own selector (see initPicker). */
(function () {
  if (window.__xkLaunch) return;
  window.__xkLaunch = 1;

  function swap(box, src) {
    if (!box || !src) return;
    var top = box.querySelector('.xk-img:last-of-type');
    if (top && top.dataset.src === src) return;
    var im = new Image();
    im.className = 'xk-img is-in';
    im.alt = '';
    im.decoding = 'async';
    im.dataset.src = src;
    im.onload = function () {
      requestAnimationFrame(function () {
        im.classList.remove('is-in');
        setTimeout(function () {
          box.querySelectorAll('.xk-img').forEach(function (o) { if (o !== im) o.remove(); });
        }, 220);
      });
    };
    im.src = src;
    box.appendChild(im);
  }

  function mark(sw) {
    var g = sw.closest('.xk-sws');
    g.querySelectorAll('.xk-sw').forEach(function (x) {
      x.classList.toggle('is-on', x === sw);
      if (x.tagName === 'BUTTON') x.setAttribute('aria-pressed', x === sw ? 'true' : 'false');
    });
    var n = g.querySelector('.xk-sws__n');
    if (n) n.textContent = sw.dataset.name || '';
  }

  function preview(sw) {
    if (sw.tagName !== 'A') return;
    var panel = sw.closest('[data-xk-panel]');
    if (!panel) return;
    mark(sw);
    swap(panel.querySelector('[data-xk-shot]'), sw.dataset.img);
    panel.querySelectorAll('[data-xk-href]').forEach(function (a) { a.href = sw.href; });
  }

  function pick(sw) {
    var io = sw.closest('[data-xk-io]');
    var side = sw.closest('[data-xk-pick]');
    if (!io || !side) return;
    mark(sw);
    swap(io.querySelector('[data-xk-side="' + side.dataset.xkPick + '"]'), sw.dataset.img);
    var p = io.querySelector('[data-xk-pick="pro"] .xk-sw.is-on');
    var l = io.querySelector('[data-xk-pick="lite"] .xk-sw.is-on');
    var map = {};
    try { map = JSON.parse(io.querySelector('[data-xk-io-map]').textContent); } catch (e) {}
    var id = p && l ? map[p.dataset.name + ' / ' + l.dataset.name] : null;
    io.querySelectorAll('[data-xk-io-href]').forEach(function (a) {
      var base = a.href.split('?')[0];
      a.href = id ? base + '?variant=' + id : base;
    });
  }

  /* 3. Bundle picker (snippets/xk-bundle-picker, inside pdpv9): tiles pick option values; the matching variant is
        selected through pdpv9's own hidden chip or list <select>, so the house pipeline does price, stock, gallery and form.
        A tile is disabled only when no available variant carries that value; picking a value whose exact combination is
        sold out moves the other choice to an available one. Fires xk:pick for the signature band's photos. */
  function initPicker(bp) {
    var root = bp.closest('[data-pdpv9]') || document;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-pdpv9-variants]').textContent) || []; } catch (e) { return; }
    var rows = bp.querySelectorAll('.xk-bp__row'), n = rows.length, state = [];
    rows.forEach(function (row, i) { var on = row.querySelector('.xk-bp__t.is-on'); state[i] = on ? on.dataset.v : null; });
    function match(st) {
      for (var k = 0; k < variants.length; k++) {
        var ok = true;
        for (var i = 0; i < n; i++) { if (variants[k].options[i] !== st[i]) { ok = false; break; } }
        if (ok) return variants[k];
      }
      return null;
    }
    function hasAvail(i, val) {
      for (var k = 0; k < variants.length; k++) { if (variants[k].available && variants[k].options[i] === val) return true; }
      return false;
    }
    bp.querySelectorAll('.xk-bp__t').forEach(function (t) {
      var ok = hasAvail(+t.dataset.xkBpOpt, t.dataset.v);
      t.disabled = !ok; t.classList.toggle('is-na', !ok);
    });
    function tileImg(i) { var t = bp.querySelector('.xk-bp__t.is-on[data-xk-bp-opt="' + i + '"]'); return t ? t.dataset.img || '' : ''; }
    function summary() {
      var el = bp.querySelector('[data-xk-bp-sum]'); if (!el) return;
      var mode = bp.dataset.xkBp, b = document.createElement('b'), parts;
      if (mode === 'kit') { var b2 = document.createElement('b'); b.textContent = state[0] + ' Pro'; b2.textContent = '2 bowls in ' + String(state[1] || '').toLowerCase() + ' carry cases'; parts = ['You get: ', b, ', spare battery, ', b2, ', mouthpiece and XKAH base coaster.']; }
      else if (mode === 'io') { b.textContent = state[0] + ' Pro + ' + state[1] + ' Lite'; parts = ['Your pair: ', b, '. AU plug converter included.']; }
      else { b.textContent = 'XKAH Pro in ' + state[0]; parts = ['In the box: ', b, ' + a spare 13,600 mAh battery.']; }
      el.textContent = '';
      parts.forEach(function (p) { el.appendChild(typeof p === 'string' ? document.createTextNode(p) : p); });
    }
    function paint() {
      bp.querySelectorAll('.xk-bp__t').forEach(function (x) {
        var on = x.dataset.v === state[+x.dataset.xkBpOpt];
        x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      bp.querySelectorAll('[data-xk-bp-cur]').forEach(function (c) { c.textContent = state[+c.dataset.xkBpCur] || ''; });
      summary();
    }
    function drive(v) {
      var chip = root.querySelector('[data-chip][data-variant-id="' + v.id + '"]');
      if (chip) { chip.click(); return; }
      var sel = root.querySelector('[data-optselect]');
      if (sel) { sel.value = String(v.id); sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    bp.addEventListener('click', function (e) {
      var t = e.target.closest('.xk-bp__t'); if (!t || t.disabled) return;
      var i = +t.dataset.xkBpOpt; state[i] = t.dataset.v;
      var v = match(state);
      if (!v || !v.available) {
        for (var k = 0; k < variants.length; k++) {
          if (variants[k].available && variants[k].options[i] === state[i]) { state = variants[k].options.slice(0, n); v = variants[k]; break; }
        }
      }
      paint();
      if (v && v.available) drive(v);
      var imgs = []; for (var j = 0; j < n; j++) imgs.push(tileImg(j));
      document.dispatchEvent(new CustomEvent('xk:pick', { detail: { mode: bp.dataset.xkBp, values: state.slice(), imgs: imgs } }));
    });
  }
  document.querySelectorAll('[data-xk-bp]').forEach(initPicker);
  document.addEventListener('xk:pick', function (e) {
    var d = e.detail || {};
    document.querySelectorAll('[data-xk-follow]').forEach(function (box) {
      var src = (d.imgs || [])[+box.dataset.xkFollow]; if (src) swap(box, src);
    });
  });

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target.closest && e.target.closest('.xk-sw[data-img]');
    if (sw && sw.tagName === 'A') preview(sw);
  });
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('a.xk-sw[data-img]');
    if (sw) preview(sw);
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('button.xk-sw');
    if (sw) pick(sw);
  });
})();
